import { DocGroupsList } from "../../../../../DocGroups"
import { Helmet } from "react-helmet-async"

const OrganizationDocGroupPage = () => {
	return (
		<>
			<Helmet>
				<title>Document Group | Org</title>
			</Helmet>
			<DocGroupsList />
		</>
	)
}

export default OrganizationDocGroupPage
